import { createContext, useContext } from "react";

/**
 * Which environment the environment-scoped screens are about.
 *
 * One piece of state for the whole shell, because there is one question. The
 * switcher in the header sets it, and Overview, Game Rules and the sidebar's
 * links all read the same value — an earlier version had Overview carrying its
 * own picker, which meant the header could say Development while the numbers
 * underneath were Production's, and nothing on screen said which.
 *
 * The context and its hooks live apart from the provider because Fast Refresh
 * is per-module: a file exporting both a component and the hooks around it
 * reloads the whole app on every edit instead of swapping the component.
 */
export interface Selection {
  envId: string | undefined;
  choose: (envId: string) => void;
}

export const EnvironmentContext = createContext<Selection>({
  envId: undefined,
  choose: () => {},
});

/** The chosen environment, or undefined before the project has any. */
export function useCurrentEnvironment(): string | undefined {
  return useContext(EnvironmentContext).envId;
}

/** The chosen environment together with the way to change it. */
export function useEnvironmentSelection(): Selection {
  return useContext(EnvironmentContext);
}
